module.exports = __webpack_public_path__ + "static/media/filter-selected-button.fa32bae1.svg";